import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../store";

const campaignState = (state: RootState) => state.campaign;

const selectCampaigns = createSelector(
  campaignState,
  (state) => state.campaigns || [],
);

const selectSelectedCampaign = createSelector(
  campaignState,
  (state) => state.selectedCampaign,
);

export const campaignSliceSelectors = {
  selectCampaigns,
  selectSelectedCampaign,
};
